<template>
  <div class="company-appointment-box">
    <div class="company-appointment-content">
      <img :src="cdnresources+'/prod/images/xiangaibao/bzjhxqb1.png'" />
    </div>
    <div class="table">
      <img :src="cdnresources+'/prod/images/xiangaibao/bzjhxqb2.png'" />
      <img :src="cdnresources+'/prod/images/xiangaibao/bzjhxqb3.png'" />
    </div>
  </div>
</template>

<script>
import { cdnresources } from '@/util/config'
export default {
  data() {
    return {
      cdnresources
    }
  },
  components: {

  }
}
</script>


<style scoped lang="scss">
.company-appointment-box {
  min-height: 100vh;
  background: #fff;
  .table{
    padding: xvw(20);
  }
}
.company-appointment-content {
 img{
  width: 100%;
  height: auto;
 }
}
.box{
  padding: 10px;
}
.table{
  width: 100%;
  border-collapse:collapse;
  tr{
    td{
      border:1px solid #F53540;
      font-size: 12px;
      color: #333;
      text-align: center;
      padding: 10px 5px;
      line-height: 18px;
    }
    td:first-child{
      width: px2rem(208);
    }
  }
  tr:first-child{
    td{
      font-size: 14px;
    }
  }
  img{
     width: 100%;
     height: 100%;
  }
}
.second_level{
  td:first-child{
    width: px2rem(500) !important;
    font-size: 12px;
  }
}
.second_level2{
  td:first-child{
    width: px2rem(500) !important;
    font-size: 12px;
  }
  td:last-child{
    text-align: center;
    width: 100px;
  }
}
</style>
